<template>
    <div>
        <div class="tab-top">
            <h2>{{ $t('digital.tabs.choosetenant.headline') }}</h2>
            <div class="text">
                <p>{{ $t('digital.tabs.choosetenant.label') }}</p><a href=""></a>
            </div>
        </div>

        <div class="seperator"></div>

        <section>

            <div v-for="(tenant, index) in tenants">
                <div class="wizard-component data-input">
                    <div class="inputs">
                        <div class="input-container">
                            <p class="subject">{{ $t('digital.tabs.choosetenant.tenant-label') }} <span
                                v-if="tenants.length > 1">#{{ index + 1 }}</span></p>
                            <p class="description">{{ $t('digital.tabs.choosetenant.byemail.text') }}</p>
                            <form>
                                <validation-provider rules="required|email" v-slot="{failed}" immediate slim>
                                    <input
                                        :class="{'has-error': failed}"
                                        type="text"
                                        v-model="tenant.email"
                                        autocomplete="false"
                                    />
                                </validation-provider>
                                <div class="delete" v-if="tenants.length > 1 && index > 0"
                                     @click="tenants.splice(index,1)">
                                    <SvgIcon icon="delete"/>
                                </div>
                            </form>
                        </div>
                    </div>
                    <!--
                    <choose-tenant
                        v-if="invitations.length > 0"
                        :invitations="invitations"
                        :selected="tenants"
                        v-model="tenants[index]"
                    /> -->
                </div>
            </div>
            <button v-if="hasExtraTenantSignature === false" class="green next-btn" @click="add()" :disabled="tenants.length === 5">
                <SvgIcon icon="plus-circle"/>
                {{ $t('digital.tabs.choosetenant.add') }}
            </button>
            <div v-if="hasExtraTenantSignature === false" class="tipsbox">
                <div class="icon">
                    <SvgIcon icon="tips-info"/>
                </div>
                <div class="text">
                    <p>{{ $t('digital.tabs.tenantinfo-tipsbox') }}</p>
                </div>
            </div>

        </section>

        <div class="seperator"></div>

        <div class="wizard-component">
            <div class="button-container">
                <button class="purple next-btn" @click="saveAndNext()" style="float: right">
                    {{ $t('digital.tabs.nextstep') }}
                </button>
            </div>
        </div>


        <!--        -->
        <!--        <div class="wizard-component data-input">-->
        <!--            <div class="inputs">-->
        <!--                <div class="input-container">-->
        <!--                    <p class="subject">{{$t('digital.tabs.choosetenant.byemail.label')}}</p>-->
        <!--                    <p class="description">{{$t('digital.tabs.choosetenant.byemail.text')}}</p>-->
        <!--                    <form>-->
        <!--                        <input type="text" v-model="value.tenant_email"/>-->
        <!--                    </form>-->
        <!--                </div>-->
        <!--            </div>-->
        <!--            <div class="tipsbox">-->
        <!--                <div class="icon">-->
        <!--                    <SvgIcon icon="tips-info"/>-->
        <!--                </div>-->
        <!--                <div class="text">-->
        <!--                    <p>{{ $t('custom-contract.tabs.tenantinfo-tipsbox') }}</p>-->
        <!--                </div>-->
        <!--            </div>-->
        <!--        </div>-->

        <!--        <div class="seperator"></div>-->
        <!--        <button v-on:click="save()" class="purple next-btn" :disabled="state === 'saving'">{{ $t('digital.tabs.nextstep') }}</button>-->
    </div>
</template>

<script>
import SvgIcon from "../../../components/Svg";

export default {
    name: "CustomContractTenant",
    props: ['value', 'state'],
    data: () => ({
        tenants: [{
            email: ''
        }],
        invitations: []
    }),
    computed: {
        hasExtraTenantSignature: function () {
            return _.filter(this.value.custom_contract_pages, {has_extra_tenant_signature : true}).length > 0
        }
    },
    components: {
        SvgIcon
    },
    methods: {
        add: function () {
            this.tenants.push({email: ''})
        },

        save: function () {
            if (this.tenants.length === 0 || this.tenants[0].email === '')
                return false;

            this.tenants = _.filter(this.tenants, (tenant) => tenant.email !== '');
            this.tenants[0].is_primary = true;

            this.$emit('saving');

            axios({
                method: 'POST',
                cancelToken: window.AuthorizationCancelSource.token,
                url: window.config.apiUrl + 'api/custom-contract/' + this.value.id + '/tenants',
                data: _.map(this.tenants, function (tenant) {
                    return {
                        email: tenant.email,
                        is_primary: tenant.is_primary || false
                    }
                })
            }).then(response => {
                this.$store.commit('setSuccessBarMessage', this.$t('successbar.label.tenant-saved'));
                this.tenants = response.data.data;
                this.value.tenants = this.tenants;
                this.$emit('input', this.value);
                this.$emit('save');
            }).catch((e) => {
                this.$emit('error', e);
            });
        },
        saveAndNext() {
            this.save();
            this.$emit('next', this.tenants);
        }
    },

    mounted() {

        if(this.value.id === undefined)
            return;

        axios({
            method: 'GET',
            cancelToken: window.AuthorizationCancelSource.token,
            url: window.config.apiUrl + 'api/custom-contract/' + this.value.id + '/tenants',
        }).then(response => {
            if (response.data.data.length > 0) {
                this.tenants = response.data.data;
            }
        });

        axios({
            method: 'GET',
            cancelToken: window.AuthorizationCancelSource.token,
            url: window.config.apiUrl + 'api/invitation/sent',
        }).then(response => {
            this.invitations = response.data.data;
        });
    },
    created() {
        this.$parent.$on('saved', this.save);
    }
}
</script>

<style scoped>

</style>
